import { render, staticRenderFns } from "./OpenNewTicket.vue?vue&type=template&id=e30a6810&scoped=true"
import script from "./OpenNewTicket.vue?vue&type=script&lang=js"
export * from "./OpenNewTicket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e30a6810",
  null
  
)

export default component.exports